import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-svgo_approval",
  "use": "icon-svgo_approval-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-svgo_approval\"><path d=\"M7 0a7 7 0 110 14A7 7 0 017 0zm3 10H4v1h6v-1zM7 3c-.919 0-1.667.79-1.667 1.765 0 .722.412 1.345 1 1.617v.853H4.834c-.459 0-.834.395-.834.883V9h6v-.882c0-.491-.374-.883-.834-.883h-1.5v-.853c.589-.272 1-.894 1-1.617C8.667 3.792 7.92 3 7 3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol